import AbstractAuthenticatedService from '@vertical-plus/vue-js-micro-service-components/lib/model/service/abstract-authenticated-service';
import DownloadTdsInvoiceTask from '@/model/task/report/download-tds-invoice-task';

export default class ReportService extends AbstractAuthenticatedService
{
    /**
     * Downloads the TDS invoice for the given month
     *
     * @param month
     * @returns
     */

    public async downloadTdsInvoice(month: string)
    {
        const task = new DownloadTdsInvoiceTask();
        task.token = this.token;
        task.month = month;

        return this.runTask(task) as Promise<void>;
    }
}